import { changeFormInputData } from "../../redux/formStateSlice";
import { amplitudeState } from "../../utility/amplitude";

/**
 * Setup scroll logics
 */
function scrollOnPaginationClick(isMobile) {
	try {
		// id of the element for scrolling
		let defaultScrollEle = "#partners-advanced-filter";

		if (isMobile) {
			defaultScrollEle = "#partners-advanced-filter .results .aboveResult";
		}

		document.querySelector(defaultScrollEle)?.scrollIntoView(true);
	} catch (e) {
		console.error(e);
	}
}

/**
 * Generate Page Number Array
 * Used by external component as well - @react/shared-component/PaginationLists/View.jsx
 */
function generatePageNumArray(current, total, isMobile) {
	try {
		let middlePages;
		let finalPagesArray = [];

		if (!isMobile) {
			if (current === 1) {
				middlePages = [current + 1, current + 2, current + 3];
			} else if (current === total) {
				middlePages = [current - 1, current - 2, current - 3];
			} else {
				middlePages = [current - 1, current, current + 1];
			}

			middlePages.forEach((item) => {
				if (item <= 1) return;
				if (item >= total) return;
				finalPagesArray.push(item);
			});
		}

		if (isMobile) {
			if (current !== 1) finalPagesArray.push(current);
		}

		// add first page to array
		finalPagesArray.unshift(1);

		// add last page to array
		finalPagesArray.push(total);

		// remove duplicated pages if there are any
		finalPagesArray = [...new Set(finalPagesArray)];

		// always smaller page num first
		return finalPagesArray.sort((a, b) => a - b);
	} catch (e) {
		console.error(e);
	}
}

/**
 * When previous or next page icon(not numbers) are clicked
 */
function whenPrevNextIconClicked(value, dispatch, formInput, currentPage) {
	try {
		if (value !== "prev" && value !== "next") return;

		let newPageNum = 0;

		if (value === "prev") newPageNum = currentPage - 1;
		if (value === "next") newPageNum = currentPage + 1;

		dispatch(
			changeFormInputData({
				...formInput,
				pagination: newPageNum,
				isResetClicked: false,
			}),
		);

		amplitudeState.formAction = null;

		scrollOnPaginationClick();
	} catch (e) {
		console.error(e);
	}
}

function whenPrevIconClicked(dispatch, formInput, currentPage) {
	try {
		whenPrevNextIconClicked("prev", dispatch, formInput, currentPage);
	} catch (e) {
		console.error(e);
	}
}

function whenNextIconClicked(dispatch, formInput, currentPage) {
	try {
		whenPrevNextIconClicked("next", dispatch, formInput, currentPage);
	} catch (e) {
		console.error(e);
	}
}

export {
	scrollOnPaginationClick,
	generatePageNumArray,
	whenPrevNextIconClicked,
	whenPrevIconClicked,
	whenNextIconClicked,
};
